import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';

export default function AccessibilityStatementPage() {
  return (
    <main className="bg-background-50 text-foreground-900 font-body">
      <Header />
      <section className="pt-32 md:pt-40 pb-16 md:pb-24">
        <div className="max-w-3xl mx-auto px-5 md:px-10">
          <p className="text-[11px] uppercase tracking-[0.24em] text-accent-700 mb-5">
            Accessibility
          </p>
          <h1 className="font-heading text-5xl md:text-7xl leading-[0.98] text-foreground-950">
            Accessibility Statement
          </h1>
          <p className="mt-6 text-lg md:text-xl leading-relaxed text-foreground-700">
            Inspire Vacation Properties is committed to making this website accessible and usable
            for all guests, owners, and visitors.
          </p>
        </div>
      </section>

      <section className="pb-20 md:pb-28">
        <div className="max-w-3xl mx-auto px-5 md:px-10 space-y-8 text-foreground-700 leading-relaxed">
          <div>
            <h2 className="font-heading text-3xl text-foreground-950 mb-3">Our Commitment</h2>
            <p>
              We want every visitor to be able to browse properties, review details, ask questions,
              and contact the Inspire team with confidence. The website includes display tools that
              can help adjust contrast, text size, spacing, motion, images, and readability.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-3xl text-foreground-950 mb-3">Ongoing Improvement</h2>
            <p>
              Accessibility is an ongoing effort. As the site grows, Inspire Vacation Properties and
              its website partners will continue improving usability, readability, navigation, and
              compatibility with assistive technologies.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-3xl text-foreground-950 mb-3">Need Help?</h2>
            <p>
              If you experience difficulty using any part of this website, please contact the Inspire
              team. We will do our best to provide the information, property details, or booking help
              you need through an accessible communication method.
            </p>
            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <a
                href="mailto:AP@InspireVP.com"
                className="inline-flex items-center justify-center gap-2 rounded-lg bg-foreground-950 px-5 py-3 text-background-50 hover:bg-accent-700 transition-colors"
              >
                Email Inspire
                <i className="ri-mail-line" />
              </a>
              <a
                href="tel:8508192764"
                className="inline-flex items-center justify-center gap-2 rounded-lg border border-background-300 px-5 py-3 text-foreground-900 hover:border-accent-500 transition-colors"
              >
                850-819-2764
                <i className="ri-phone-line" />
              </a>
            </div>
          </div>

          <p className="pt-6 border-t border-background-200 text-sm text-foreground-500">
            Last updated: August 28, 2026
          </p>
        </div>
      </section>
      <Footer />
    </main>
  );
}
